import Header from "../../../../components/Header/Header";
import Footer from "../../../../components/Footer/Footer";
import ArticlePlaceholder from "../../../../components/Placeholder/Placeholder";

export default function Loading() {
  return (
    <>
      <Header />
      <ArticlePlaceholder />
      <Footer />
    </>
  );
}
